/** The API and the web app must agree on these literal names — apps/web can't import apps/api's config. */
export const SESSION_COOKIE_NAME = 'chukua.session';
export const CSRF_COOKIE_NAME = 'chukua.csrf';
/** Carries the login step-up challenge id between /auth/login and /auth/totp/verify — set only while 2FA is pending, never alongside a session. */
export const TOTP_CHALLENGE_COOKIE_NAME = 'chukua.totp-challenge';
/** Carries the forced password-change challenge id between /auth/login and /auth/password/complete — set only while a reset-issued password is pending replacement, never alongside a session. */
export const PASSWORD_CHANGE_CHALLENGE_COOKIE_NAME = 'chukua.password-change-challenge';
